import React, {useState} from 'react'
import './css/Game.css'

function Game(props){
    const [pick, setPick] = useState(props.game[0])
    const game_height = {
        height: props.height
    }
    return (
            <div className="game">
                <p>{pick}</p>
                <button onClick={() => setPick(props.game[0])}>{props.game[0]}</button>
                <button onClick={() => setPick(props.game[1])}>{props.game[1]}</button>
            </div>
    )
}

export default Game;